import React from 'react';
import { CircleX } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RotatingDeleteIconProps {
  className?: string;
  size?: number;
}

export const RotatingDeleteIcon: React.FC<RotatingDeleteIconProps> = ({
  className,
  size,
}) => {
  return (
    <CircleX
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 transition-transform duration-300 group-hover:rotate-90',
        className,
      )}
    />
  );
};
